var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children as ReactChildren, useCallback, cloneElement, } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { LinkListBase } from './styled';
function LinkList(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const renderChildren = useCallback(() => ReactChildren.map(children, (child) => (React.createElement("li", null, cloneElement(child, Object.assign(Object.assign({}, child.props), { children: (React.createElement(React.Fragment, null,
            React.createElement("span", null, child.props.children),
            React.createElement(SystemIcon, { name: "arrow-right" }))) }))))), [children]);
    return React.createElement(LinkListBase, Object.assign({}, props), renderChildren());
}
export default LinkList;
